import store from '@/store/index';
import { i18n } from '@/lang';
import {
    ROUTES_EQUIPMENT,
    ROUTES_EQUIPMENT_LIST,
    ROUTES_EQUIPMENT_LIST_FORM_CATEGORY,
    ROUTES_EQUIPMENT_LIST_FORM_EQUIPMENT,
    ROUTES_EQUIPMENT_LIST_ITEM_LOGS,
    ROUTES_UNAUTHORIZED
} from '@/constants/routes';

export default {
    path: '/equipment-list',
    name: ROUTES_EQUIPMENT,
    component: () => import(/* webpackChunkName: 'equipment' */ '@/views/EquipmentList.vue'),
    redirect: { name: ROUTES_EQUIPMENT_LIST },
    children: [
        {
            path: '/equipment-list',
            name: ROUTES_EQUIPMENT_LIST,
            beforeEnter: guardRouteEquipment,
            component: () => import(/* webpackChunkName: 'equipment' */ '@/components/equipment-list/Equipment.vue')
        },
        {
            path: 'form-category/:categoryId?',
            name: ROUTES_EQUIPMENT_LIST_FORM_CATEGORY,
            beforeEnter: guardRouteEquipment,
            component: () =>
                import(/* webpackChunkName: 'equipment' */ '@/components/equipment-list/EquipmentAddCategory.vue')
        },
        {
            path: 'form-equipment/:categoryId?/:equipmentId?',
            name: ROUTES_EQUIPMENT_LIST_FORM_EQUIPMENT,
            beforeEnter: guardRouteEquipment,
            component: () =>
                import(/* webpackChunkName: 'equipment' */ '@/components/equipment-list/EquipmentAddEquipment.vue')
        },
        {
            path: ':equipmentId?/logs',
            name: ROUTES_EQUIPMENT_LIST_ITEM_LOGS,
            beforeEnter: guardRouteEquipment,
            component: () =>
                import(/* webpackChunkName: 'equipment' */ '@/components/equipment-list/EquipmentListItemLogs.vue')
        }
    ]
};

function guardRouteEquipment(to, from, next) {
    if (!store.getters['userPermissions/canManageInventory']) {
        store.dispatch('notifyError', { message: i18n.t('notAuthorizedToSeeThisPage') });
        next({ name: ROUTES_UNAUTHORIZED });
    } else {
        next();
    }
}
